import { z } from 'zod';

import { createApi } from '../core';

export const SalesforceCase = z.object({
  id: z.number(),
  sfid: z.string(),
  category: z.string(),
  subCategory: z.string(),
  subject: z.string(),
  description: z.string(),
  status: z.string(),
  createddate: z.string(),
  closeddate: z.string().nullable(),
});
export type SalesforceCase = z.infer<typeof SalesforceCase>;

export const Response = z.object({
  cases: SalesforceCase.array(),
});

export const salesforceCaseApi = createApi.group(['voucher'], (createKey) => {
  return {
    all: createApi.query({
      queryKey: createKey(['all']),
      queryFn: (enrolmentSfId: string) => {
        return createApi.fetch({
          path: ['salesforce', 'cases', enrolmentSfId],
          method: 'GET',
          sign: true,
          validator: Response,
          basePath: 'portalAPI',
        });
      },
      staleTime: createApi.time(0, 'seconds'),
      refetchInterval: createApi.time(5, 'minutes'),
    }),
  };
});
